import { gql } from 'apollo-boost';

export const getRooms = gql`
    query{
        rooms{
            _id,
            name,
            link,
            branch_info{
                _id,
                name
            }
        }
    }
`;

export const getRoomsByUser = gql`
    query GetRoomsByUser(
        $user: ID!,
    ){
        roomsByUser(
            user: $user
        ){
            _id,
            name,
            link,
            branch_info{
                _id,
                name
            }
        }
    }
`;

export const getRoom = gql`
    query GetRoom(
        $_id: ID!,
    ){
        room(
            _id: $_id
        ){
            _id,
            name,
            link,
            branch_info{
                _id,
                name
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/query/rooms.js